import { render, staticRenderFns } from "./UserInformationContent.vue?vue&type=template&id=06fc331c&scoped=true"
import script from "./UserInformationContent.vue?vue&type=script&lang=js"
export * from "./UserInformationContent.vue?vue&type=script&lang=js"
import style0 from "./UserInformationContent.vue?vue&type=style&index=0&id=06fc331c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc331c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VForm,VIcon,VProgressCircular})
